module.exports = __webpack_public_path__ + "static/media/header-img.997fde30.jpg";